"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _I18n = _interopRequireDefault(require("I18n"));

var _react = _interopRequireWildcard(require("react"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _deprecated = _interopRequireDefault(require("../utils/propTypes/deprecated"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _ShareInput = _interopRequireDefault(require("../decorators/ShareInput"));

var _IMESafe = _interopRequireDefault(require("../decorators/IMESafe"));

var _InputConstants = require("./InputConstants");

var _refObject = _interopRequireDefault(require("../utils/propTypes/refObject"));

var _Functions = require("../core/Functions");

var _FieldsetContext = require("../context/FieldsetContext");

var createWarningMessage = function createWarningMessage(propName) {
  return {
    message: "UITextArea: the " + propName + " prop has been deprecated. Please use `UICharacterCounter` instead.",
    key: "UITextArea: " + propName + " prop"
  };
};

var UITextArea = _react.default.createClass({
  displayName: "UITextArea",
  mixins: [_reactAddonsPureRenderMixin.default],
  propTypes: {
    cols: _react.PropTypes.number,
    counter: (0, _deprecated.default)(_react.PropTypes.bool, createWarningMessage),
    disabled: _react.PropTypes.bool,
    error: _react.PropTypes.bool,
    inputRef: _refObject.default,
    placeholder: _react.PropTypes.string,
    readOnly: _react.PropTypes.bool,
    resize: _react.PropTypes.oneOf(['vertical', 'horizontal', true, false]),
    rows: _react.PropTypes.number,
    styled: _react.PropTypes.bool.isRequired,
    use: _react.PropTypes.oneOf(Object.keys(_InputConstants.USE_CLASSES)),
    value: _react.PropTypes.string
  },
  getDefaultProps: function getDefaultProps() {
    return {
      error: false,
      resize: 'vertical',
      styled: true,
      value: ''
    };
  },
  render: function render() {
    var _this$props = this.props,
        className = _this$props.className,
        counter = _this$props.counter,
        error = _this$props.error,
        inputRef = _this$props.inputRef,
        resize = _this$props.resize,
        styled = _this$props.styled,
        use = _this$props.use,
        value = _this$props.value,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["className", "counter", "error", "inputRef", "resize", "styled", "use", "value"]);
    return _react.default.createElement(_FieldsetContext.Consumer, null, function (_ref) {
      var fieldSize = _ref.size;
      var computedClassName = (0, _classNames.default)('form-control', 'private-form__control', 'private-text-area', className, _InputConstants.INPUT_SIZE_OPTIONS[fieldSize], _InputConstants.USE_CLASSES[use], {
        'private-text-area--with-counter': counter,
        'private-form__control--unstyled': !styled,
        'private-form__control--error': error,
        'private-text-area--no-resize': resize === false,
        'private-text-area--vertical-resize': resize === 'vertical',
        'private-text-area--horizontal-resize': resize === 'horizontal'
      });

      var renderedTextArea = _react.default.createElement("textarea", (0, _extends2.default)({}, rest, {
        className: computedClassName,
        ref: (0, _Functions.wrapRefObject)(inputRef),
        value: value
      }));

      if (counter) {
        var count = value ? value.length : 0;
        return _react.default.createElement("div", {
          className: "private-text-area__counter-wrapper"
        }, renderedTextArea, _react.default.createElement("span", {
          className: "private-text-area__counter",
          "aria-live": "polite",
          "aria-atomic": "false"
        }, count === 1 ? _I18n.default.text('salesUI.UITextArea.characterCounter.one', {
          count: count
        }) : _I18n.default.text('salesUI.UITextArea.characterCounter.other', {
          count: count
        })));
      }

      return renderedTextArea;
    });
  }
});

var _default = (0, _ShareInput.default)((0, _IMESafe.default)((0, _Controllable.default)(UITextArea)));

exports.default = _default;
module.exports = exports.default;